/**
 * Third-party hosts that are legitimate navigation / popup targets. Our own domains are not
 * listed here: they come from the server (`siteData.global.domains.own`, SB-6783) and are
 * merged in by `getAllowedHosts()`. Anything NOT matching the merged list (as an exact host
 * or a subdomain) is treated as a potential forced redirect when it happens without user
 * interaction shortly after page load.
 *
 * Keep this list tight — a false positive only produces a beacon (no user-facing effect),
 * but a too-broad list would let a malicious host slip through unreported.
 */
export const ALLOWED_HOSTS: string[] = [
    // Legit ad / provider infrastructure that may open popups on genuine clicks
    'ptgncdn.com',
    'trafficjunky.com',
    'trafficjunky.net',
    'tsyndicate.com',
    'exoclick.com',
    'juicyads.com',
    'trafficstars.com',
    'popcash.net',
    // First-party ad host used by our own interstitial/promo code (postgen_ads.js) — not malvertising.
    'aj1987.online',
];

/** Own domains injected by the server (read per call; absent on older cached pages) plus `ALLOWED_HOSTS`. */
export function getAllowedHosts(): string[] {
    return [...(window.siteData?.global?.domains?.own ?? []), ...ALLOWED_HOSTS];
}

/** True if `host` is one of the allowed hosts or a subdomain of one. */
export function isAllowedHost(host: string, allowedHosts: string[] = getAllowedHosts()): boolean {
    const h = host.toLowerCase();
    return allowedHosts.some((allowed) => h === allowed || h.endsWith(`.${allowed}`));
}
